import React, { FC, useEffect, useRef, useState } from 'react';
import { BaseLevels, Col, Heading, Row } from '@kb-front/ui-kit';
import CashImage from 'shared/assets/images/cash.png';
import Container from 'shared/components/Container';
import { channelType } from 'shared/consts';
import { useGeneralInfoContext } from 'shared/context/WithGeneralInfo/GeneralInfoContext';
import { EProductCode, ESalesChannel } from 'shared/enum';
import { IProductData } from 'shared/model';

import SkeletonProductInfo from './Skeleton';

import './index.scss';

interface IProps {
  productData: IProductData;
}

const ProductInfo: FC<IProps> = ({ productData }) => {
  const { productCode } = useGeneralInfoContext();
  const imgRef = useRef<HTMLImageElement>(null);
  const [isImgLoaded, setIsImgLoaded] = useState(false);

  useEffect(() => {
    if (imgRef.current?.complete && imgRef.current.naturalWidth > 0) {
      setIsImgLoaded(true);
    }
  }, []);

  const titleBrend = productData?.title?.substring(0, productData?.title?.indexOf(' '));
  const titleDescription = productData?.title?.substring(productData?.title?.indexOf(' '), productData?.title?.length);

  const cashloanAmountInfo = productData?.details?.map(({ title, info }: IProductData, index: number) => (
    <Col md={3} key={`${index * index}productItem`} xs={6} className="cashloan-info__container__content__tarif-list__item">
      <div>{info}</div>
      <div>{title}</div>
    </Col>
  ));

  const imgClassBox = productCode === EProductCode.GTKR ? 'cash-img-box' : 'credit-img-box';
  const imgClass = productCode === EProductCode.GTKR ? 'cash-img-box__img' : 'credit-img-box__img';
  const imgLoadedClass = isImgLoaded ? `${imgClass}--loaded` : '';

  return (
    <div className={`cashloan-info product-bgColor__${channelType}`}>
      <Container className="cashloan-info__container">
        {channelType === ESalesChannel.BIRBANK_AZ && <div className="bg-birbank-mark" />}
        <div className={`${imgClassBox} cash-img-box__${channelType}`}>
          <img ref={imgRef} src={CashImage} alt="card" className={`${imgClass} ${imgLoadedClass}`} onLoad={() => setIsImgLoaded(true)} />
        </div>
        {productData?.title ? (
          <div className={`cashloan-info__container__content cashloan-info__container__content__${channelType}`}>
            <div className="cashloan-info__container__content__header">
              <div className="cashloan-info__container__content__header__title">
                <Heading level={BaseLevels.L1}>
                  <span className={`dangerColor-${channelType}`}> {titleBrend} </span>
                  <span> {titleDescription} </span>
                </Heading>
              </div>
              <div className="cashloan-info__container__content__header__desc">
                <span>{productData?.description}</span>
              </div>
            </div>
            <Row className="cashloan-info__container__content__tarif-list">{cashloanAmountInfo}</Row>
          </div>
        ) : (
          <SkeletonProductInfo hideCard />
        )}
      </Container>
    </div>
  );
};

export default ProductInfo;
